import { getNoshowList, getNoshowDetailInfo, cancelNoshow, cancelNoshowRequest } from "apis/meetings/no-show";
import { TNoShowDetailInfo } from "../NoshowReservationDetail/types";
import { TNoShowListItem, TSortType } from "./types";

export class NoShowListServices {
  constructor() {}

  //* INFO: 노쇼 예약 관리 목록 조회
  async getNoshowList(
    startDate: Date,
    endDate: Date,
    isRepeatRsv: boolean,
    sortType: TSortType,
    page: number
  ): Promise<{ list: TNoShowListItem[]; totalPageNumber: number; success: boolean }> {
    //* startDate 시간 필터를 00분 00초로 설정
    startDate.setHours(0, 0, 0, 0);

    //* endDate 시간 필터를 23시 59분 59초로 설정
    endDate.setHours(23, 59, 59, 999);
    const list = await getNoshowList(startDate, endDate, isRepeatRsv, sortType, page);
    if (list.success && list.data) {
      return { success: true, list: list.data.noshowList, totalPageNumber: list.data?.totalPageNumber };
    } else {
      return { success: false, list: [], totalPageNumber: 0 };
    }
  }

  //* INFO: 노쇼 예약 관리 목록 취소
  async cancelNoshow(instanceId: string): Promise<boolean> {
    const res = await cancelNoshow(instanceId);
    return res.success;
  }

  //* INFO: 노쇼 예약 취소 요청 처리
  async requestCancelNoshow(instanceId: string) {
    const res = await cancelNoshowRequest(instanceId);
    return res;
  }

  //* INFO: 노쇼 예약 상세 정보 조회
  async getNoshowDetailInfo(id: string, startDate: Date, endDate: Date): Promise<TNoShowDetailInfo | null> {
    try {
      const res = await getNoshowDetailInfo(id, startDate, endDate);
      if (res.success && res.data) {
        return res.data;
      } else {
        return null;
      }
    } catch (error: any) {
      return null;
    }
  }

  //* INFO: N개월전 날짜 구하기
  getStartDateByMonth(month: number): Date {
    const date = new Date();
    date.setMonth(date.getMonth() - month);
    return date;
  }
}
